//
// RankInfo.js
// BIRD
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../lib";
import "../../models/dataDefinition/common/rank/RankBase";
import "../../models/dataDefinition/DataItem";

var RankInfo = createModule("BIRD::RankInfo", ["commons::PropertyOwner","commons::BaseModel","BIRD::BIRDModel","BIRD::RankBase"], EventDispatcher, [
    {
        INVALID_USER_INPUT: 50017,
    },
    {
        rankBy: 1,
        description: 7,
        groupBy: 1,
        detail: 2,
        label: 7,
        otherAvailable: 2,
    },
    ,
    {
        userInput: 7,
    },
    {
        getAvailableUserInput: [[7]],
        getAvailableParameters: [[7]],
    },
    ,
    ,
]);
export default RankInfo;
